import { IconType, SvgIcon } from './SvgIcon';

export const CameraDisabledIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <g clipPath="url(#clip0_5_1957)">
      <path
        d="M7.10645 4H9.33311C9.68673 4 10.0259 4.14048 10.2759 4.39052C10.526 4.64057 10.6664 4.97971 10.6664 5.33333V7L14.1651 4.95867C14.2158 4.92911 14.2733 4.91344 14.332 4.91324C14.3906 4.91304 14.4483 4.92832 14.4992 4.95753C14.55 4.98675 14.5923 5.02887 14.6216 5.07963C14.651 5.1304 14.6665 5.18802 14.6664 5.24667V10.7107"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6668 10.6667C10.6668 11.0203 10.5264 11.3594 10.2763 11.6095C10.0263 11.8595 9.68712 12 9.3335 12H2.66683C2.31321 12 1.97407 11.8595 1.72402 11.6095C1.47397 11.3594 1.3335 11.0203 1.3335 10.6667V5.33333C1.3335 4.97971 1.47397 4.64057 1.72402 4.39052C1.97407 4.14048 2.31321 4 2.66683 4H4.00016"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.3335 1.3335L14.6668 14.6668"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1957">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

CameraDisabledIcon.displayName = 'CameraDisabledIcon';
